const $emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

const $defaultLocation = "全部"; //香港

const $checkImageLoaded = (src) => {
    return new Promise(function (resolve, reject) {
        const image = new Image();
        image.addEventListener('load', resolve);
        image.addEventListener('error', reject);
        image.src = src;
    });
}

const $checkInputValid = (_inputList,_ticketItems) => {
    return new Promise(function (resolve, reject) {
    	console.log("$checkInputValid");
        let allValid = 0;
        let hasApiList=false;
        _inputList.forEach(function (item) {
            allValid += item.mandatory && item.type!='APILIST' ? 1 : 0;
            allValid += item.mandatory && item.type=='APILIST' && _ticketItems==undefined? 1 : 0;
            if (item.type=='APILIST'){
            	hasApiList = true;
            }
        });

        if(_ticketItems!=undefined && hasApiList){
        	allValid += _ticketItems.length;
        }

        for (let i = 0; i < _inputList.length; i++) {
            if (_inputList[i].mandatory) {
            	if (_inputList[i].type == "APILIST") {
            			_inputList[i].infoInputOptions.forEach(function(item){
            				if(item!=undefined){
            					allValid -= 1;
            				}
            			});
                } else if (_inputList[i].type == "LIST" || _inputList[i].type == "RADIOBUTTON") {
                    for (let j = 0;j < _inputList[i].infoInputOptions.length;j++) {
                        if (_inputList[i].infoInputOptions[j].selected) {
                            allValid -= 1;
                            break;
                        }
                    }
                } else if (_inputList[i].type == "FREETEXT") {
                    if (_inputList[i].value != undefined && _inputList[i].value != "") {
                        if (_inputList[i].questionKey == "bkger_email") {
                            if (_inputList[i].value.match($emailRegex)) {
                                allValid -= 1;
                            }
                        } else {
                            allValid -= 1;
                        }
                    }
                } else if (_inputList[i].type == "DATE") {
                    if (_inputList[i].value != undefined && _inputList[i].value != "") {
                        allValid -= 1;
                    }
                }
            }
        }
        return resolve(allValid == 0 ? true : false);
    });
}

const $convertDateToChinese = (str) => {
    let result = "";
    if (str.indexOf("-") != -1) {
        const arr = str.split('-');
        if (arr.length == 3) {
            result = arr[0] + "年" + arr[1] + "月" + arr[2] + "日";
        }
    }
    return result;
}

const $displayOrderList = [
    { value: "RECOMMEND", name: "推薦" },
    { value: "POPULAR", name: "最受歡迎" },
    { value: "PRICEUP", name: "價格(低至高)" },
    { value: "PRICEDOWN", name: "價格(高至低)" }
]
/*
const $bannerImg = [
    "banner_staycation.jpg",
    "banner_flycation.jpg",
    "banner_1daytour.jpg",
    "banner_1daytour2.jpg",
    "banner_multidaytour.jpg",
    "banner_airport.jpg",
    "banner_bus.jpg",
    "banner_othertransport.jpg",
    "banner_family.jpg",
    "banner_food.jpg",
    "banner_gym.jpg",
    "banner_handmade.jpg",
    "banner_local.jpg",
    "banner_night.jpg",
    "banner_others.jpg",
    "banner_outdoor.jpg",
    "banner_aquarium.jpg",
    "banner_attraction.jpg",
    "banner_museum.jpg",
    "banner_performance.jpg",
    "banner_theme.jpg",
    "banner_transport.jpg",
    "banner_tickets.jpg",
    "banner_train.png",
    "banner_groundtransfer.png",
]

const $bottomTxt = [
    "EGL Tours 提供世界各地的短線精華遊，你可以按自己心水參加半日遊、一日遊或多日遊，由經驗團隊細心安排行程規劃，再由導遊貼心帶領下遊覽，無論是品嚐主題美食，還是欣賞大自然景色、體驗歷史文化、到當地人氣街頭景點朝聖，各種精彩短線旅行推介應有盡有。例如在日本欣賞富士山美景，或到韓國的韓劇拍攝場地朝聖。愛好自由行的你，毋須再因行程規劃、搜尋自由行好去處而傷腦筋，立即報名參加，跟我們一起出發吧。",
    "EGL Tours 提供世界各地的半日遊行程，從熱門的日本當地遊到歐洲精華遊都有囊括，半日觀光時間讓你感受當地的文化精華之餘，還可以利用另外半日時間自由活動，靈活有彈性。例如參加日本東京半日遊，便可以在遊覽景點名勝後，再去各大商場血拼購物，滿足不同願望。無論是想感受各地歷史文化、品嚐地道美食或到景點朝聖，我們的半日遊都可滿足你，毋須猶疑，立即預訂，展開開心半日遊吧。",
    "EGL Tours 提供世界各地的一日遊行程，由日本、台灣、韓國，到英國、法國、澳洲都應有盡有。我們的團隊仔細安排行程規劃，再由經驗導遊貼心帶領下遊覽，讓你以一日時間遊覽當地最地道的景點，毋須為交通及餐飲安排費心，例如精選日本一日遊便以東京、大阪、沖繩等城市為目的地，規劃出美食、大自然、歷史文化等主題一日遊，滿足大家不同的願望。熱愛旅遊的你立即報名參加，跟我們一起出發吧。",
    "EGL Tours 提供世界各地的多日遊行程，例如日本深度遊，到訪立山黑部和世界遺產白川鄉，同時感受大自然景色的壯觀和合掌屋的童話感。參加我們的深度遊只需在當地集合，再由經驗導遊帶領下一連幾天走訪人氣景點、品嚐主題美食、欣賞大自然景色和體驗歷史文化，住宿、交通一一為你準備妥富。想在深度遊前後多玩幾天由你自己話事，既可享受自由行的無拘無束，又不用花費太多時間作行程規劃，完全可以一次滿足你多個願望，立即報名展開不一樣的旅程吧。",
    "EGL Tours 搜羅世界各地的特色體驗活動，滿足不同人士的需要，類型包括：文化體驗、戶外活動、親子活動、夜遊體驗、美食/烹飪和觀光導覽。文化體驗讓你親身體驗當地文化，例如在京都穿上和服變身當地人；戶外活動給你呼吸郊外空氣的機會，來個叢林飛索或在牧場親親小動物，遠離繁囂；親子活動讓可以全家參與，例如一起親親可愛海豚，親子同樂；夜遊體驗充分利用黃昏及晚上時間，可以在船上邊吃晚餐邊欣賞城市夜景，感受城市與日間不同的另一面；美食/烹飪讓你品嚐當地美食，更有機會參加烹飪班製作地道料理；觀光導覽可以遊覽當地景點，了解當地。無論你想輕鬆放電或是深度旅遊，我們都可以滿足你的需求，快來預訂，準備新旅程吧。",
    "EGL Tours 搜羅世界各地文化體驗節目，無論是在京都穿上和服參拜神社、於登別伊達時代村中欣賞忍者和花魁表演，還是由當地人帶領遊覽景點，都讓你有機會更深入體驗當地文化。如果你希望來一次不一樣的文化旅遊就不要猶豫，趕快來看看，網上預訂還可節省現場排隊時間！",
    "EGL Tours 搜羅世界各地的戶外活動，無論是動態的運動項目，例如滑雪、泰國叢林飛索，還是靜態的近郊活動如在日本近郊採摘水果、在台灣近郊牧場近距離接觸小動物，都可以在這裏找到。你可以根據自己的動靜程度，盡情選購心宜活動。若果想呼吸一下郊外的空氣，遠離繁囂，就來預訂活動吧。",
    "EGL Tours 搜羅世界各地的夜遊體驗行程，例如在台場大江戶溫泉物語浸溫泉、韓國安山星光村欣賞浪漫燈飾、觀光船上邊享用晚餐邊欣賞夜景等。我們明白旅行的時間總令人感覺過得特別快，最好連晚上也可靈活運用，夜遊體驗便可讓你運用晚間，夜貓一族還不快快預約準備出發？",
    "EGL Tours 搜羅世界各地的親子活動，類型有動有靜，無論是去日本主題樂園放電、在韓國滑雪場體驗雪上樂趣，還是到台灣牧場親親動物、去日本果園採摘水果都可找到。一家大小去旅行最怕行程不能滿足所有人，更怕活動不適合小朋友。我們的活動適合一家人，拉近親子距離，趕快來預訂吧，從此帶小朋友去旅行不再是煩心事。",
    "EGL Tours 搜羅世界各地美食/烹飪活動，美食愛好者可以在特色餐廳進餐，或者在地道景點品嚐當地美食，例如日本新宿機械人餐廳和悉尼塔旋轉餐廳；烹飪愛好者則可以在老師指導下，烹調地道料理，例如韓國蔘雞湯DIY和泰菜烹飪班。我們相信美食也是一種文化表現，品嚐和烹調當地料理，不只為旅途增添趣味，更可輕鬆了解更多當地文化，快來看看有沒有心儀活動吧。",
    "EGL Tours 搜羅世界各地與觀光導覽相關的行程，從傳統旅遊景點、自然景點，到特色主題樂園、養生溫泉館等，各種類的行程都有所囊括。你可以根據自己的興趣喜好，自由組合心目中的旅程。立即預訂，來一個心水自由行吧。",
    "EGL Tours 提供各類優惠交通套票，無論是日本JR Pass、台灣高鐵優惠券或韓國火車証，都可在這裏找到，讓你在自由行中輕鬆前往各個目的地。我們更有點對點接送服務，除了機場接送，還可選擇直達旅遊景點，方便快捷。你更可以租WIFI蛋或買旅行電話卡，在國外便可隨時隨地輕鬆上網，不怕和家人、旅伴失聯。而且WIFI蛋可以在香港機場24小時交收，方便快捷。",
    "EGL Tours 提供各地機場交通套票，例如成田機場京成電鐵Skyliner、關西機場巴士、香港機場快線等，無論你想乘坐巴士或電鐵來往機場，各式交通工具都可搜尋到。出發前先購買，便不用到時拖著行李徬徨搜索。如果想更舒適享受，還可以預訂各地機場接送服務，例如日本機場接送。無論是共乘車或獨立包車，都可一出機場即上車，免去拖著行李四處走的煩惱，日本、台灣、韓國等熱門旅遊地均有此項服務。",
    "EGL Tours 提供點對點專車接送服務，服務包括機場接送、市內點對點接送等，直達機場、市中心、酒店和旅遊景點。多個國家地區均有此項服務，例如日本包車接送和泰國包車接送。你可根據旅行人數，選擇不同車型，無論小家庭或大團體都可享受舒適的私人旅程。即使你是一人旅行也不用擔心，我們亦有共乘的專車服務，不用一個人支付多人車費。",
    "EGL Tours 提供各地火車、地鐵、輕軌等鐵路交通券，你可以選擇喜愛的交通方式，在各個景點輕鬆來回。我們亦提供地區性的交通券，包括日本JR Pass、香港高鐵訂票服務和台北高鐵優惠車票。讓你輕鬆來回各大城市，體驗各地文化，例如拿著日本JR Pass由北海道玩到九州四國，或者在西九龍站坐香港高鐵直達內地多個車站，在不同的城市行走。",
    "EGL Tours 提供各地巴士交通券，例如日本巴士、歐洲巴士、觀光巴士、香港機場巴士等。你可以根據自己需要來預訂各種類的巴士券，若果你喜歡較隨性的旅行方式，便可買周遊巴士券，隨時出發，無限次數乘搭，更自由自在；如果你想省去搜尋資料的時間，就選擇觀光巴士券，跟隨精選的景點路線遊覽城市吧。",
    "EGL Tours 除了提供陸上交通工具的交通套票外，如火車、巴士，還搜羅了船券、纜車等特別交通工具的交通套票，你可以根據自己的喜好來預訂。快來預訂，等待出發吧。",
    "EGL Tours 明白在國外旅遊隨時需要上網搜尋資訊，或者與親友聯絡，因此我們提供各地WIFI蛋和SIM卡，包括日本WIFI蛋、台灣WIFI蛋等。你可以在香港機場24小時交收WIFI蛋，而且一機在手可多人連線，輕鬆方便。而SIM卡則設定簡單，毋須上網註冊，落機即用。在外地仍如在家中與人自由聯繫，立即上網預訂，安心等待旅程出發日吧。",
    "EGL Tours 搜羅世界各地的景點及表演門票，滿足不同人士的需要，門票種類包括：主題樂園、博物館及藝術館、水族館及動物園、特色景點及表演比賽。主題樂園可以體驗各種主題設施，感受歡樂氣氛；博物館及藝術館帶來文化知識，讓你沉澱思緒；水族館及動物園有可愛的動物們，治癒心靈；特色景點包括各種獨特旅遊區，帶來不同體驗；表演比賽讓你以觀眾角度參與，感受當地文化。無論你好動或愛靜，我們都可以滿足你的需求，快來預訂，準備新旅程吧。",
    "EGL Tours 搜羅世界各地的主題樂園門票，例如日本迪士尼、台灣麗寶雙樂園、韓國愛寶樂園和泰國Line Village等均可在這裏找到：日本迪士尼是大人小朋友的夢想世界，隨時可在路上偶遇米奇、米妮，與他們影相打卡；台灣麗寶雙樂園，一次玩盡水陸設施，開心休閒又消暑；韓國愛寶樂園既有刺激機動遊戲又有可愛動物王國，親子同樂；泰國Line Village內有20間Line人物主題房間，粉絲可以盡情影相打卡。還有更多各地主題樂園，無論是夢幻童真、刺激好玩、溫馨親子，都一一囊括，一定可以滿足你的希望，趕快來預約門票吧。",
    "EGL Tours 搜羅世界各地的博物館及藝術館門票，讓你感受文化藝術，更有學習新知識的機會。例如在巴黎羅浮宮思考《蒙羅麗莎》微笑的含義，從《維納斯》雕像感受古典女性美。無論是歷史文物、繪畫雕塑、趣味知識，都有機會接觸到，你可以根據自己的喜好選購。想來一趟長知識、開眼界的知性旅行的話，就快點來預訂吧。",
    "EGL Tours 搜羅世界各地的水族館及動物園門票，例如日本水族館大阪海遊館和新加坡動物園夜間野生動物園：大阪海遊館是日本最壯觀水族館之一，擁有15個再現太平洋水域的大水槽和世界最大的魚“鯨鯊”；新加坡夜間動物園是世界第一座夜間動物園，你可以坐在遊覽車近距離觀看野生動物的夜間生活。無論你喜愛陸上動物或水中生物，你都可根據自己的喜好，在我們網站預訂水族館或動物園門票。快快來預訂，親親大自然的可愛動物們吧。",
    "EGL Tours 搜羅世界各地的特色景點門票，無論是於東京Skytree遠眺東京的大都會景色，或是晚上在新加坡濱海灣花園欣賞擎天樹猶如阿凡達世界的夢幻表演，我們都為你準備。若果在計劃行程時發現自己想遊覽主題樂園、博物館等以外的地方，你便可以在這裏取得一些靈感，還可以直接預訂門票，展開新旅程。",
    "EGL Tours 搜羅世界各地的表演及比賽門票，讓你以觀眾角度感受當地文化或參與緊張賽事。我們提供多種類型的表演節目門票，例如有當地文化展示、韓國K-Pop音樂節目、多媒體舞台表演等；而比賽方面主要是運動競技，例如緊張刺激的曼谷泰拳比賽。無論你的興趣是甚麼，都有機會在這裏找到你想要的，趕快來看看和預訂吧。"
]
*/
const $daysMin = ["日", "一", "二", "三", "四", "五", "六"]

const $months = [
    "一月",
    "二月",
    "三月",
    "四月",
    "五月",
    "六月",
    "七月",
    "八月",
    "九月",
    "十月",
    "十一月",
    "十二月"
]

const $monthsShort = [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月"
]

const $mainMenu = [
    { name: "東瀛遊首頁", link: "https://www.egltours.com/travel/showIndex", isRouterLink: false },
    { name: "自由行", link: "https://www.egltours.com/trip-packages/?product=package", isRouterLink: false },
    { name: "當地玩樂", link: "/", isRouterLink: true }
]

const $aboutUsMenu = [
    { name: "聯絡我們", link: "https://www.egltours.com/travel/showContact", isRouterLink: false },
    { name: "合作機會", link: "/partnership", isRouterLink: true },
    { name: "分行資料", link: "https://www.egltours.com/travel/showCompany?id=3", isRouterLink: false },
    { name: "電話查詢及報名中心", link: "https://www.egltours.com/travel/showCompany?id=4", isRouterLink: false }
]

const $onlineServiceMenu = [
    { name: "訂單網上付款", link: "https://www.egltours.com/tour/indexOnline3in1", isRouterLink: false },
    { name: "常見問題", link: "/faq", isRouterLink: true },
    { name: "旅遊達人精選推介", link: "/recommendation", isRouterLink: true }
]

const $termsAndPolicyMenu = [
    { name: "私隱政策", link: "https://www.egltours.com/travel/tch/policy/privacy_rule.jsp", isRouterLink: false },
    { name: "使用條款", link: "https://www.egltours.com/travel/tch/policy/term_of_use.jsp", isRouterLink: false }
]

const $showAllLists = [
    "點對點接送",
    "交通券及儲值卡",
    "來往機場",
    "鐵路",
    "巴士",
    "其他交通",
    "WIFI",
    "火車証",
    "日本火車証&周遊券",
    "台灣火車証&周遊券",
    "韓國火車証",
    "歐洲火車証"
]

export default {
    install: (app) => {
        app.provide('emailRegex', $emailRegex);
        app.provide('defaultLocation', $defaultLocation);
        app.provide('checkImageLoaded', $checkImageLoaded);
        app.provide('checkInputValid', $checkInputValid);
        app.provide('convertDateToChinese', $convertDateToChinese);
        app.provide('displayOrderList', $displayOrderList);
        //app.provide('bannerImg', $bannerImg);
        //app.provide('bottomTxt', $bottomTxt);
        app.provide('daysMin', $daysMin);
        app.provide('months', $months);
        app.provide('monthsShort', $monthsShort);
        app.provide('mainMenu', $mainMenu);
        app.provide('aboutUsMenu', $aboutUsMenu);
        app.provide('onlineServiceMenu', $onlineServiceMenu);
        app.provide('termsAndPolicyMenu', $termsAndPolicyMenu);
        app.provide('showAllLists', $showAllLists);
    }
}